<template>
  <div>
    <slot name="ativador" :callbackAtivarDialog="() => this.dialog_ativo = true" />

    <SysDialogFullscreen v-model="dialog_ativo">
      <template #titulo>
        <v-btn icon class="ml-n2 mr-5" dark @click="dialog_ativo = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <div class="d-flex align-center">
          <span>Detalhamento</span>

          <v-divider vertical dark class="mx-2" />

          <div class="font-12">
            <slot name="titulo.append">
              {{ histograma || "Total Geral" }}
              <v-icon dark small>mdi-chevron-right</v-icon>
              {{ data }}
            </slot>
          </div>
        </div>

        <v-spacer />

        <slot name="titulo.right" />
      </template>

      <Tabela
        v-if="dialog_ativo"
        :filtros_basicos="filtros_basicos"
        :histograma="histograma"
        :nivel_servico="nivel_servico"
        :idsegmento="idsegmento"
        :idfornecedor="idfornecedor"
        :idproduto="idproduto"
        :idgrupo="idgrupo"
        :produto_combinado="produto_combinado"
        :data="data"
        :ativar_filtro_revenda_direta_detalhes_produto="ativar_filtro_revenda_direta_detalhes_produto"
        class="ml-2 mr-1"
      />
    </SysDialogFullscreen>
  </div>
</template>

<script>
import SysDialogFullscreen from "../../../../padraoDeLayout/SysDialogFullScreen.vue";
import Tabela from "./Tabela.vue";

export default {
  name: "DetalhamentoDuploClique",
  components: {
    SysDialogFullscreen,
    Tabela,
  },
  props: {
    filtros_basicos: Object,
    histograma: String,
    nivel_servico: String,
    idsegmento: Number,
    idfornecedor: Number,
    idproduto: String,
    idgrupo: Number,
    data: String,
    produto_combinado: Boolean,
    ativar_filtro_revenda_direta_detalhes_produto: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog_ativo: false,
  }),
}
</script>

<style scoped>

</style>
